// extracted by mini-css-extract-plugin
export default {"content":"GetOffer_content__4vuAJ","title_first":"GetOffer_title_first__BTQFb","margin":"GetOffer_margin__JCdKC"};